import { ChangeEvent, FC, useState } from 'react';

import { FileType } from '@/shared/components/FileType';
import { COLORS } from '@/shared/constants/colors';
import { Button } from '@/shared/uikitV2/Button';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { numbers } from '@/shared/utils/numbers';
import { BtnClose } from '@/widgets/modals/components/BtnClose';

import { useModalsStore } from '../../modals.store';
import { EditCommentProps } from '../../types';

import {
  Actions,
  Body,
  Container,
  Header,
  Info,
  Name,
  StyledDrawer,
  Textarea,
  Title,
} from './styled';

// TODO modal container RightSide
export const EditCommentModal: FC<EditCommentProps> = ({
  file,
  comment,
  maxCommentLength = 1000,
  onChange,
}) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'editComment' });
  const modals = useModalsStore();
  const [value, setValue] = useState(comment);

  const handleClose = () => modals.closeModal();
  const onConfirm = () => {
    modals.closeModal();
    if (value !== undefined) {
      onChange(value);
    }
  };

  const handleChange = (ev: ChangeEvent<HTMLTextAreaElement>) => {
    setValue(ev.target.value);
  };

  return (
    <StyledDrawer width={400} footer={null} closable={false} onClose={handleClose} open>
      <Container>
        <Header>
          <Title className="truncate" size={22} bold>
            {t('title')}
          </Title>
          <BtnClose style={{ position: 'absolute', right: 24, top: 24 }} onClick={handleClose} />
        </Header>
        <Body style={{ marginRight: 4 }} className="uikitScrollbar">
          <Info>
            <FileType style={{ flexShrink: 0 }} type={file.type} />
            <Name>
              <span className="truncate" style={{ fontWeight: 700 }}>
                {file.name}
              </span>
              <span style={{ fontSize: 12, color: COLORS.systemDark200 }}>
                {file.size ? numbers.formatMemoryFromBytes(file.size) : '-'}
              </span>
            </Name>
          </Info>
          <Textarea
            placeholder={t('placeholder')}
            value={value}
            maxLength={maxCommentLength}
            onChange={handleChange}
          />
        </Body>
        <Actions>
          <Button type="text" onClick={handleClose}>
            {t('btnCancel')}
          </Button>
          <Button onClick={onConfirm}>{t('btnConfirm')}</Button>
        </Actions>
      </Container>
    </StyledDrawer>
  );
};
